var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleCheckFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 5.07191C17.2068 5.7686 18.2105 6.76833 18.912 7.97215C19.6135 9.17597 19.9885 10.5421 19.9997 11.9354C20.011 13.3286 19.6582 14.7007 18.9762 15.9157C18.2942 17.1307 17.3068 18.1465 16.1115 18.8626C14.9163 19.5787 13.5548 19.9702 12.1618 19.9984C10.7687 20.0266 9.39251 19.6904 8.1693 19.0233C6.94608 18.3562 5.91832 17.3811 5.18775 16.1947C4.45718 15.0083 4.04913 13.6517 4.004 12.2591L4 11.9999L4.004 11.7407C4.0488 10.3591 4.45084 9.01268 5.17093 7.83271C5.89101 6.65273 6.90456 5.67948 8.11276 5.00782C9.32097 4.33616 10.6826 3.98903 12.0649 4.00026C13.4472 4.0115 14.803 4.38071 16.0001 5.07191Z",
    fill: "#F79E1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V12.5042C13 13.0565 12.5523 13.5042 12 13.5042C11.4477 13.5042 11 13.0565 11 12.5042V8Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 15,
    width: 2.5,
    height: 2.5,
    rx: 1.25,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckFilled);
export default __webpack_public_path__ + "static/media/CircleCheckFilled.f7fd6f1bef6ff95fb6e41c4cff1090ee.svg";
export { ForwardRef as ReactComponent };